// Mock data for AiStonks landing page

export const mockWaitlistSubmit = async (email) => {
  // Simulate API call delay
  await new Promise(resolve => setTimeout(resolve, 1000));
  
  // Mock successful submission
  console.log('Mock: Waitlist email submitted:', email);
  return {
    success: true,
    message: 'Successfully joined the waitlist!'
  };
};

export const exampleCommands = [
  "Buy 10 shares of Reliance",
  "Show my portfolio",
  "Sell my NIFTY calls"
];

export const howItWorksSteps = [
  {
    number: "01",
    title: "Say what you want to do",
    description: "Just type in plain English. No complex trading screens.",
    example: '"Buy 10 shares of Reliance"'
  },
  {
    number: "02",
    title: "Review before anything happens",
    description: "Clear confirmation. Full control. Nothing executes without your approval.",
    example: null
  },
  {
    number: "03",
    title: "Execute confidently",
    description: "Every action stays in your control.",
    example: null
  }
];

export const whyAiStonksFeatures = [
  {
    title: "No complex trading screens",
    description: "Investment decisions shouldn't require a learning curve. Just natural language."
  },
  {
    title: "No financial jargon",
    description: "We translate complex market terminology into clear, simple actions."
  },
  {
    title: "Built for clarity and confidence",
    description: "Every action is transparent. You always know exactly what's happening."
  },
  {
    title: "Built for investors and traders",
    description: "Clear actions. Full control. No unnecessary complexity."
  }
];

export const trustPoints = [
  "You maintain full control over every transaction",
  "Nothing executes automatically without your confirmation",
  "Paper trading is available when you want to test before going live.",
  "Clear, transparent confirmations before every action"
];
